module.exports = {
      id: "Warranty 2-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Warranty 2-usage",
      toString: function () {
        return this.url;
      }
    }